
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M300.71 601.52a89.89 89.89 0 01-4.49 28.13 93.15 93.15 0 01-3.74 9.5A89.77 89.77 0 01129 638.07a85.28 85.28 0 01-3.2-8.31 89.72 89.72 0 11174.89-28.21z"}}),_c('path',{attrs:{"data-name":"path940","d":"M767.71 602.28a89.6 89.6 0 01-4.49 28.13 90.89 90.89 0 01-3.74 9.5A89.75 89.75 0 01596 638.83a82.86 82.86 0 01-3.21-8.31 89.72 89.72 0 11174.89-28.21z"}}),_c('path',{attrs:{"data-name":"path940","d":"M767.71 602.28a89.6 89.6 0 01-4.49 28.13 90.89 90.89 0 01-3.74 9.5A89.75 89.75 0 01596 638.83a82.86 82.86 0 01-3.21-8.31 89.72 89.72 0 11174.89-28.21z"}}),_c('path',{attrs:{"d":"M493 398.23H64.74l-34.57 89.24 25.13 10.17 2.79-6.39 41.76 15.2 23.15 8.42a123.5 123.5 0 01211.5 86.69 124.6 124.6 0 01-.85 14.47l.58.29h67.4l70.67-192.86 14.37.09zM654.46 428.23H538.77l-68.41 188h80.52a127.88 127.88 0 11254.86-19.64l154.72-38.71V428.23h-306zM803.18 389.04H661.35l30-92.93h111.83v92.93z"}})])
          )
        }
      }
    